/**
 * Delivery Info Calculator
 * Calcula e exibe datas de entrega baseado em dias úteis
 */

document.addEventListener('DOMContentLoaded', function() {
  // Função para adicionar dias úteis a uma data
  function addBusinessDays(date, days) {
    let currentDate = new Date(date);
    let addedDays = 0;
    
    while (addedDays < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      // Pula fins de semana (Sábado = 6, Domingo = 0)
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        addedDays++;
      }
    }
    
    return currentDate;
  }
  
  // Função para formatar data em português
  function formatDateBR(date) {
    const months = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];
    
    const day = date.getDate();
    const month = months[date.getMonth()];
    
    return `${day} de ${month}`;
  }
  
  // Procura por todos os elementos de data de entrega
  const deliveryDateElements = document.querySelectorAll('[id^="delivery-dates-display"]');
  
  deliveryDateElements.forEach(function(element) {
    const minDays = parseInt(element.dataset.minDays) || 0;
    const maxDays = parseInt(element.dataset.maxDays) || 0;
    
    if (minDays > 0 && maxDays > 0) {
      const today = new Date();
      const minDate = addBusinessDays(today, minDays);
      const maxDate = addBusinessDays(today, maxDays);
      
      const minFormatted = formatDateBR(minDate);
      const maxFormatted = formatDateBR(maxDate);
      
      element.textContent = `${minFormatted} e ${maxFormatted}`;
      
      // Mostra badge se entrega for rápida (menos de 5 dias)
      if (maxDays <= 5) {
        const sectionId = element.id.replace('delivery-dates-display-', '');
        const badge = document.getElementById(`delivery-badge-display-${sectionId}`);
        if (badge) {
          badge.style.display = 'inline';
        }
      }
    } else {
      element.textContent = 'Prazo não disponível';
    }
  });
  
  // Atualiza datas quando variante muda
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      if (!event.data || !event.data.html) return;
      
      // Procura por novos elementos de delivery info no HTML atualizado
      const parser = new DOMParser();
      const doc = parser.parseFromString(event.data.html.innerHTML, 'text/html');
      
      deliveryDateElements.forEach(function(element) {
        const sectionId = element.id.replace('delivery-dates-display-', '');
        const newElement = doc.getElementById(element.id);
        
        if (newElement) {
          const minDays = parseInt(newElement.dataset.minDays) || 0;
          const maxDays = parseInt(newElement.dataset.maxDays) || 0;
          
          // Atualiza o dataset do elemento atual
          element.dataset.minDays = minDays;
          element.dataset.maxDays = maxDays;
          
          if (minDays > 0 && maxDays > 0) {
            const today = new Date();
            const minDate = addBusinessDays(today, minDays);
            const maxDate = addBusinessDays(today, maxDays);
            
            const minFormatted = formatDateBR(minDate);
            const maxFormatted = formatDateBR(maxDate);
            
            element.textContent = `${minFormatted} e ${maxFormatted}`;
            
            // Atualiza badge
            const badge = document.getElementById(`delivery-badge-display-${sectionId}`);
            if (badge) {
              badge.style.display = maxDays <= 5 ? 'inline' : 'none';
            }
            
            // Mostra/esconde o bloco de delivery
            const deliveryBlock = element.closest('.x-block-delivery-info');
            if (deliveryBlock) {
              deliveryBlock.style.display = 'block';
            }
          } else {
            element.textContent = 'Prazo não disponível';
            
            // Esconde o bloco se não houver dados
            const deliveryBlock = element.closest('.x-block-delivery-info');
            if (deliveryBlock) {
              deliveryBlock.style.display = 'none';
            }
          }
        }
      });
    });
  }
});
